"use client";

import { AntdRegistry } from "@ant-design/nextjs-registry";
import { App, ConfigProvider, theme } from "antd";
import ruRU from "antd/locale/ru_RU";

export default function AntProvider({ children }: { children: React.ReactNode }) {
  return (
    <AntdRegistry>
      <ConfigProvider
        locale={ruRU}
        theme={{
          algorithm: theme.defaultAlgorithm,
          token: {
            colorPrimary: "#1677ff",
            colorBgLayout: "#f5f5f5",
            colorBgContainer: "#ffffff",
            colorText: "rgba(0, 0, 0, 0.88)",
            colorTextSecondary: "rgba(0, 0, 0, 0.65)",
            colorBorder: "#d9d9d9",
            borderRadius: 6,
            fontFamily: 'var(--font-open-sans), "Open Sans", sans-serif',
          },
          components: {
            Layout: {
              headerBg: "#ffffff",
              bodyBg: "#f5f5f5",
              siderBg: "#ffffff",
            },
            Menu: {
              itemSelectedColor: "#1677ff",
              itemSelectedBg: "#e6f4ff",
            },
          },
        }}
      >
        <App>{children}</App>
      </ConfigProvider>
    </AntdRegistry>
  );
}
